/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{a as n,f as t}from"../../../../chunks/vec3f64.js";class r{constructor(n,t){this.vec3=n,this.id=t}}function s(t,s){return new r(n(t),s)}function c(n,s,c,e){return new r(t(n,s,c),e)}export{r as LocalOrigin,c as fromValues,s as fromVector};
